import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./App.css";
import ReviewForm from "./Components/ReviewForm/ReviewForm";
import LandingPage from "./Components/Landing_Page/Landing_Page";
import Login from "./Components/Login/Login";
import SignUp from "./Components/Sign_Up/Sign_Up";
import ProfileCard from "./Components/ProfileCard/ProfileCard";
import ReportsLayout from "./Components/ReportsLayout/ReportsLayout";
import InstantConsultation from "./Components/InstantConsultation/InstantConsultation";
import BookingConsultation from "./Components/BookingConsultation";
import Healthblog from "./Components/Healthblog/Healthblog";
import SelfCheckup from "./Components/SelfCheckup/SelfCheckup";
import Home from "./Components/Home/Home";
import Navbar from "./Components/Navbar/Navbar";
import Footer from "./Components/Footer/Footer";
import Seo from "./Components/Seo/Seo";
import Notification from "./Components/Notification/Notification";
import "bootstrap/dist/css/bootstrap.min.css";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Navbar />
        <Seo />
        <main className="App-main">
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/home" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<SignUp />} />
            <Route path="/instantconsultation" element={<InstantConsultation />} />
            <Route path="/bookingconsultation" element={<BookingConsultation />} />
            <Route path="/healthblog" element={<Healthblog />} />
            <Route path="/selfcheckup" element={<SelfCheckup />} />
            <Route path="/reviewform" element={<ReviewForm />} />
            <Route path="/profilecard" element={<ProfileCard />} />
            <Route path="/reportslayout" element={<ReportsLayout />} />
          </Routes>
        </main>
        <Footer />
        <Notification />
      </BrowserRouter>
    </div>
  );
}

export default App;
